import { render, staticRenderFns } from "./BillPayerDetails.vue?vue&type=template&id=1c2832f8&scoped=true"
import script from "./BillPayerDetails.vue?vue&type=script&lang=js"
export * from "./BillPayerDetails.vue?vue&type=script&lang=js"
import style0 from "./BillPayerDetails.vue?vue&type=style&index=0&id=1c2832f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c2832f8",
  null
  
)

export default component.exports